import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityTimeline = ({ activities = [], className = "" }) => {
  const getActivityIcon = (type) => {
    const iconMap = {
      exercise_completed: "CheckCircle",
      plan_updated: "FileText",
      milestone_achieved: "Award",
      goal_set: "Target",
      streak_milestone: "Flame",
      assessment_completed: "ClipboardCheck"
    };
    return iconMap?.[type] || "Activity";
  };

  const getActivityColor = (type) => {
    const colorMap = {
      exercise_completed: "text-success bg-success/10",
      plan_updated: "text-primary bg-primary/10",
      milestone_achieved: "text-warning bg-warning/10",
      goal_set: "text-secondary bg-secondary/10",
      streak_milestone: "text-error bg-error/10",
      assessment_completed: "text-accent bg-accent/10"
    };
    return colorMap?.[type] || "text-muted-foreground bg-muted";
  };

  const formatDate = (date) => {
    const now = new Date();
    const activityDate = new Date(date);
    const diffInHours = Math.floor((now - activityDate) / (1000 * 60 * 60));
    
    if (diffInHours < 1) return "Just now";
    if (diffInHours < 24) return `${diffInHours}h ago`;
    if (diffInHours < 48) return "Yesterday";
    return activityDate?.toLocaleDateString();
  };

  return (
    <div className={`space-y-4 ${className}`}>
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-foreground">Recent Activity</h3>
        <Icon name="Clock" size={16} className="text-muted-foreground" />
      </div>
      <div className="space-y-3 max-h-96 overflow-y-auto">
        {activities?.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground">
            <Icon name="Activity" size={32} className="mx-auto mb-2 opacity-50" />
            <p className="text-sm">No recent activity</p>
            <p className="text-xs">Complete exercises to see your progress here</p>
          </div>
        ) : (
          activities?.map((activity, index) => (
            <div key={activity?.id || index} className="flex items-start space-x-3">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${getActivityColor(activity?.type)}`}>
                <Icon name={getActivityIcon(activity?.type)} size={16} />
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <p className="text-sm font-medium text-foreground truncate">
                    {activity?.title}
                  </p>
                  <span className="text-xs text-muted-foreground flex-shrink-0 ml-2">
                    {formatDate(activity?.timestamp)}
                  </span>
                </div>
                
                {activity?.description && (
                  <p className="text-xs text-muted-foreground mt-1 line-clamp-2">
                    {activity?.description}
                  </p>
                )}
                
                {activity?.metadata && (
                  <div className="flex items-center space-x-2 mt-2">
                    {activity?.metadata?.points && (
                      <span className="inline-flex items-center space-x-1 text-xs bg-success/10 text-success px-2 py-1 rounded-full">
                        <Icon name="Plus" size={10} />
                        <span>{activity?.metadata?.points} pts</span>
                      </span>
                    )}
                    {activity?.metadata?.streak && (
                      <span className="inline-flex items-center space-x-1 text-xs bg-warning/10 text-warning px-2 py-1 rounded-full">
                        <Icon name="Flame" size={10} />
                        <span>{activity?.metadata?.streak} day streak</span>
                      </span>
                    )}
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ActivityTimeline;